import aiCubeImage from "@/assets/ai-cube.jpg";
import aiRunnersImage from "@/assets/ai-runners.jpg";
import circuitBoardImage from "@/assets/circuit-board.jpg";
import teamsExpertsImage from "@/assets/teams-experts.jpg";
import newYearImage from "@/assets/2025-new-year.png";
import aiClockImage from "@/assets/ai-clock.png";
import mediaRevolutionImage from "@/assets/media-revolution.png";
import aiImplementationImage from "@/assets/ai-implementation.png";
import svenskarnaInternetImage from "@/assets/svenskarna-internet.png";
import autumnTrendsImage from "@/assets/autumn-trends.png";
import teams2024Image from "@/assets/teams-2024.png";
import aiAgentsWorldImage from "@/assets/ai-agents-world.png";
import aiKnowledgeValueImage from "@/assets/ai-knowledge-value.png";
import aiRealEstateImage from "@/assets/ai-real-estate.png";
import aiSecurityImage from "@/assets/ai-security.png";
import aiTrends2026Image from "@/assets/ai-trends-2026.png";
import aiToolSelectionImage from "@/assets/ai-tool-selection.png";

export interface NewsArticle {
  id: string;
  title: string;
  excerpt: string;
  date: Date;
  category: string;
  externalLink: string;
  image?: string;
  author?: string;
}

export const newsArticles: NewsArticle[] = [
  {
    id: "21",
    title: "Konsten att välja rätt AI-verktyg. Best-of-breed eller plattform?",
    excerpt: "Alla pratar om AI, men betydligt färre har en tydlig strategi för hur rätt verktyg faktiskt väljs. Ska man satsa på den senaste spetslösningen för varje behov eller bygga vidare på en sammanhållen plattform som redan finns i organisationen? I den här artikeln reder vi ut hur du kan navigera mellan modell, app och plattform för att fatta mer hållbara och affärsnära AI-beslut.",
    date: new Date("2026-02-25"),
    category: "AI Strategy",
    externalLink: "https://www.linkedin.com/pulse/konsten-att-v%C3%A4lja-r%C3%A4tt-ai-verktyg-best-of-breed-eller-plattform-y79tf/",
    image: aiToolSelectionImage,
    author: "AI-labbet"
  },
  {
    id: "20",
    title: "5 heta AI-trender 2026!",
    excerpt: "Året börjar närma sig sitt slut och det har blivit dags att blicka in i nästa. Ett bra tillfälle att reflektera över det som har varit och vad som kommer att ske framöver.",
    date: new Date("2025-12-22"),
    category: "AI Innovation",
    externalLink: "https://www.linkedin.com/pulse/5-heta-ai-trender-2026-ai-labbet-bgujc/",
    image: aiTrends2026Image,
    author: "AI-labbet"
  },
  {
    id: "19",
    title: "AI från ett säkerhetsperspektiv",
    excerpt: "Redan 2019 fick VD:n för ett brittiskt energibolag ett telefonsamtal som lät precis som att hans chef beordrade honom att göra en överföring av pengar. Han skickade 220 000 euro till en \"leverantör\", för att senare få reda på att rösten var en klonad AI-deepfake av hans chef.",
    date: new Date("2025-10-30"),
    category: "AI Security",
    externalLink: "https://www.linkedin.com/pulse/ai-fr%C3%A5n-ett-s%C3%A4kerhetsperspektiv-ai-labbet-ydhrf",
    image: aiSecurityImage,
    author: "AI-labbet"
  },
  {
    id: "18",
    title: "AI ur ett fastighetsperspektiv",
    excerpt: "Smarta fastigheter har varit på tapeten länge och applicering av AI på allt insamlat data kan ge enorma värdeffekter.",
    date: new Date("2025-08-27"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/ai-ur-ett-fastighetsperspektiv-ai-labbet-sboff",
    image: aiRealEstateImage,
    author: "AI-labbet"
  },
  {
    id: "17",
    title: "Vad är värdet på kunskap i AI-eran?",
    excerpt: "Utrullning av nya generativa AI-modeller och uppdatering av de etablerade står som spön i backen. Det är verkligen en hissnande känsla att befinna sig mitt i den gigantiska transformation som sker just nu.",
    date: new Date("2025-07-03"),
    category: "AI Innovation",
    externalLink: "https://se.linkedin.com/posts/ai-labbet_vad-%C3%A4r-v%C3%A4rdet-p%C3%A5-kunskap-i-ai-eran-activity-7346447488129597442-p9JV",
    image: aiKnowledgeValueImage,
    author: "AI-labbet"
  },
  {
    id: "16",
    title: "I en värld av agenter – en reflektion om leverantörens roll",
    excerpt: "Hej agenten, kan du betala min faktura till golfklubben?; Hej agenten, kan du boka ett restaurangbesök till mig på en fransk restaurang i Stockholm?",
    date: new Date("2025-05-30"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/i-en-v%C3%A4rld-av-agenter-reflektion-om-leverant%C3%B6rens-roll-ai-labbet-hetff",
    image: aiAgentsWorldImage,
    author: "AI-labbet"
  },
  {
    id: "9",
    title: "5 heta AI trender 2025",
    excerpt: "Nytt år innebär en chans att reflektera över året som har gått och det som ligger framför oss.",
    date: new Date("2025-01-14"),
    category: "AI Innovation",
    externalLink: "https://www.linkedin.com/pulse/5-heta-ai-trender-2025-ai-labbet-8japf/",
    image: newYearImage,
    author: "AI-labbet"
  },
  {
    id: "10",
    title: "AI år är kortare än hundår!",
    excerpt: "Häromdagen satt vi på AI-labbet och summerade den senaste månadens händelser inom AI-världen och kunde konstatera hur oerhört mycket som händer hela tiden och hur snabbt utvecklingen sker just nu.",
    date: new Date("2024-12-19"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/ai-%C3%A5r-%C3%A4r-kortare-%C3%A4n-hund%C3%A5r-ai-labbet-lduqf/",
    image: aiClockImage,
    author: "AI-labbet"
  },
  {
    id: "11",
    title: "Från murvlar till maskiner: AI revolutionerar mediabranschen",
    excerpt: "AI kommer att ställa om våra arbetssätt i grunden. I sätten vi arbetar, våra förmågor att analysera information, hur vi skapar innehåll eller kommunicerar med andra människor.",
    date: new Date("2024-11-25"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/fr%C3%A5n-murvlar-till-maskiner-ai-revolutionerar-mediabranschen-67gcc/",
    image: mediaRevolutionImage,
    author: "AI-labbet"
  },
  {
    id: "12",
    title: "Så tar du in AI i verksamheten",
    excerpt: "Nina Rapp och Henrik Byström ger sina bästa tips för att lyckas med AI-implementeringen på jobbet.",
    date: new Date("2024-10-15"),
    category: "AI Strategy",
    externalLink: "https://vdtidningen.se/sa-tar-du-in-ai-i-verksamheten-digitalisering-it/",
    image: aiImplementationImage,
    author: "Stina Eriksson"
  },
  {
    id: "13",
    title: "Reflektioner på årets Svenskarna och internetstudie 2024",
    excerpt: "Det har återigen blivit dags för lansering av den årliga 'Svenskarna och internet' studien som tas fram av Internetstiftelsen.",
    date: new Date("2024-09-30"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/reflektioner-p%C3%A5-%C3%A5rets-svenskarna-och-internetstudien-2024-ai-labbet-43z8f/",
    image: svenskarnaInternetImage,
    author: "AI-labbet"
  },
  {
    id: "14",
    title: "Höstens hetaste AI trender",
    excerpt: "Vi på AI-labbet delar med oss av några av de hetaste trenderna inom AI just nu efter en intensiv höst.",
    date: new Date("2024-09-22"),
    category: "AI Innovation",
    externalLink: "https://www.linkedin.com/pulse/h%C3%B6stens-hetaste-ai-trender-ai-labbet-tgfcf/",
    image: autumnTrendsImage,
    author: "AI-labbet"
  },
  {
    id: "15",
    title: "Superexperterna är tillbaka: Här är 99 nya tips för Microsoft Teams",
    excerpt: "AI-labbets Henrik Byström är ännu en gång med i den digra skaran av experter som delar med sig av 99 tips i Teams.",
    date: new Date("2024-04-08"),
    category: "AI Innovation",
    externalLink: "https://techtidningen.se/superexperterna-ar-tillbaka-har-ar-99-nya-tips-for-microsoft-teams/",
    image: teams2024Image,
    author: "Gabriel Nilsson"
  },
  {
    id: "5",
    title: "Vart är världen på väg? AI-resan har bara börjat…",
    excerpt: "Det är lätt att bli överväldigad av den snabba utvecklingen av AI-tjänster som rullas ut på löpande band och i en aldrig sinande ström, samtidigt börjar många människor uppleva en sorts 'AI-fatigue' där det kan upplevas tröttsamt att det pratas om AI i alla möjliga och omöjliga sammanhang.",
    date: new Date("2025-03-26"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/vart-%25C3%25A4r-v%25C3%25A4rlden-p%25C3%25A5-v%25C3%25A4g-ai-resan-har-bara-b%25C3%25B6rjat-ai-labbet-yciff/",
    image: aiCubeImage,
    author: "AI-labbet"
  },
  {
    id: "6",
    title: "Är AI-hajpen över?",
    excerpt: "Det massmediala intresset för att skriva om AI och teknikens enorma framfart har minskat de senaste månaderna och det kan snarare upplevas som att intresset ligger i att skriva om de så kallade 'magnifika sju' topp bolagens eventuella kursfall på börsen. Så är AI-hajpen över nu?",
    date: new Date("2025-02-17"),
    category: "Industry Insights",
    externalLink: "https://www.linkedin.com/pulse/%25C3%25A4r-ai-hajpen-%25C3%25B6ver-ai-labbet-ftuaf/",
    image: aiRunnersImage,
    author: "AI-labbet"
  },
  {
    id: "7",
    title: "Välkommen på Inspirationsfrukost",
    excerpt: "Välkommen på en spännande inspirationsföreläsning om AI:s framfart inom näringslivet med experter från AI-strategiföretaget AI Lab Sweden AB (AI-labbet) och Logitech!",
    date: new Date("2025-02-17"),
    category: "Events",
    externalLink: "https://lyyti.events/p/aiinspirationsfrukost",
    image: circuitBoardImage,
    author: "AI-labbet"
  },
  {
    id: "8",
    title: "Superexperterna är tillbaka: 99 helt nya tips för Microsoft Teams och Copilot",
    excerpt: "Succélistan är återigen tillbaka. För fjärde året i rad har vi samlat 99 tips för att få ut max av Microsoft Teams.",
    date: new Date("2025-01-28"),
    category: "AI Innovation",
    externalLink: "https://techtidningen.se/samarbetsverktyg-superexperterna-ar-tillbaka-99-helt-nya-tips-for-microsoft-teams-och-copilot/",
    image: teamsExpertsImage,
    author: "Gabriel Nilsson"
  }
];

// Helper function to get the latest news articles
export const getLatestNews = (count: number): NewsArticle[] => {
  return newsArticles
    .sort((a, b) => b.date.getTime() - a.date.getTime())
    .slice(0, count);
};